import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MainService } from 'src/app/app.service';
import { AnalysisDetailsService } from './analysis-details.service';
import { PoBreadcrumbItem } from '@po-ui/ng-components';
@Component({
  selector: 'app-analysis-details',
  templateUrl: './analysis-details.component.html',
  styleUrls: ['./analysis-details.component.css']
})
export class AnalysisDetailsComponent {
  id: string;
  breadcrumbItems: PoBreadcrumbItem[] = [];
  analysis: any = {};
  loading: boolean = false;

  resultTableColumns: any[] = [
    { property: 'database', label: 'Análises', width: '80%' },
    { property: 'approved', label: 'Resultado', type: 'label', labels: [
      { value: true, color: 'blue', label: 'Aprovado' },
      { value: false, color: 'rgb(224, 40, 40)', label: 'Reprovado' },
    ] }
  ]

  resultTableItems: any[] = this.analysis.results;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private mainService: MainService,
    private analysisDetailsService: AnalysisDetailsService,
  ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params) => {
      this.id = params['id'];
      this.router.navigate([this.router.url]);
    });

    this.getAnalysisDetails();
    
    this.breadcrumbItems = [
      { label: 'Minhas análises', link: '/menu/query-analyzer' },
      { label: this.id, link: '/menu/query-analyzer/' + this.id}
    ]

  }
  
  getAnalysisDetails() {
    this.loading = true;
    
    this.analysisDetailsService.getAnalysisByID(this.id).subscribe((response: any) => {
      this.analysis = response;
      this.resultTableItems = this.analysis.results;
      this.loading = false;
    }, (error) => {
      console.error('Error fetching analysis details:', error);
      this.loading = false;
    });

    this.loading = false;
  }

  analyzeWithAI() {
    this.loading = true;

    this.analysisDetailsService.analyzeWithAI(this.id).subscribe((response: any) => {
      this.getAnalysisDetails();
      this.loading = false;
    }, (error) => {
      console.error('Error analyzing with AI:', error);
      this.loading = false;
    });
  }

  downloadAnalysis() {
    this.analysisDetailsService.downloadAnalysis(this.id).subscribe((blob: Blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `query-analysis-${this.id}.txt`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, (error) => {
      console.error('Error downloading analysis:', error);
    });
  }

}

